(() => {
  angular
    .module('app.campaign')
    .controller('CampaignDmsController', CampaignDms);

  CampaignDms.$inject = [
    '$filter',
    '$timeout',
    '$location',
    'CampaignService',
    'CampaignManagerService',
  ];

  function CampaignDms(
    $filter,
    $timeout,
    $location,
    CampaignService,
    CampaignManagerService,
  ) {
    const vm = this;
    const cloneRoute = /\/(((create)(\/(\d*))?(\/(sameTrackpoints|newTrackpoints))?)\/dms)/;

    vm.isDmsActive = false;

    vm.campaign = CampaignManagerService.getCampaignData();
    vm.isCloneMode = cloneRoute.test($location.path());
    vm.isDmsEnabled = CampaignManagerService.getDms().enabled;

    vm.dms = {
      DMSName: vm.campaign.name,
      email: $('#current-user').data('email'),
      advertiserName: '',
      channels: [],
      comments: '',
      ...CampaignManagerService.getDms(),
    };

    const updateDms = props => {
      vm.dms = {
        ...vm.dms,
        ...props,
      };

      CampaignManagerService.updateDms(vm.dms);
    };

    vm.onDmsToggle = () => {
      vm.isDmsEnabled = !vm.isDmsEnabled;
      updateDms({
        enabled: vm.isDmsEnabled,
      });
    };



    /* ************************************************************* */
    /* **************************** Name *************************** */
    /* ************************************************************* */
    vm.onChangeDMSName = () => {
      CampaignManagerService.updateDms(vm.dms);
    };



    /* ************************************************************* */
    /* *************************** Email *************************** */
    /* ************************************************************* */
    vm.onEmailChange = () => {
      vm.hasEmail = vm.dms.email;
      vm.isValidEmail = vm.hasEmail && $filter('isValidEmail')(vm.dms.email);
    }


    /* ************************************************************* */
    /* ************************* Trackpoints *********************** */
    /* ************************************************************* */
    vm.availableChannels = [
      'tv2',
      'nent',
      'discovery',
    ];
    vm.availableTrackpoints = vm.campaign.trackpoints.map(item => ({ ...item }));
    vm.trackingPointsByChannel = vm.availableChannels.map(channel => ({ channel }));
    vm.channelPlaceholder = 'Select tracking points';

    vm.getChannelByName = name => vm.trackingPointsByChannel.find(item => item.channel === name);
    const getTrackingPointByCode = (cid, tailcode) => vm.availableTrackpoints
      .find(item => (item.cid === cid && item.tailcode === tailcode));

    const updateChannels = () => {
      const selected = vm.availableTrackpoints.filter(item => !!item.isSelectedForChannel);
      const channels = selected.map(({ cid, tailcode, isSelectedForChannel }) => ({
        cid,
        tailcode,
        channel: isSelectedForChannel,
      }));

      updateDms({
        channels
      });
    };

    const updateChannelLabel = channel => {
      vm.getChannelByName(channel).label = vm.availableTrackpoints
        .filter(item => item.isSelectedForChannel === channel)
        .map(item => item.name)
        .join(', ');
    };

    const initChannels = channels => {
      if (channels) {
        channels.forEach(({ cid, tailcode, channel }) => {
          const point = getTrackingPointByCode(cid, tailcode);
          if (point) {
            point.isSelectedForChannel = channel;
          }
          updateChannelLabel(channel);
        });
      } else if (vm.dms.channels.length !== 0) {
        vm.dms.channels.forEach(({ cid, tailcode, channel }) => {
          const point = getTrackingPointByCode(cid, tailcode);
          if (point) {
            point.isSelectedForChannel = channel;
          }
          updateChannelLabel(channel);
        });
      } else {
        vm.availableChannels.forEach(channel => {
          vm.availableTrackpoints.forEach(({ cid, tailcode }) => {
            const point = getTrackingPointByCode(cid, tailcode);
            if (point && point.name.toLowerCase().includes(channel)) {
              point.isSelectedForChannel = channel;
              updateChannelLabel(channel);
            }
          });
        });
      }
    };

    initChannels();

    vm.onSelectTrackingPoint = ({ cid, tailcode }, channel, event) => {
      const selected = vm.availableTrackpoints.filter(item => item.isSelectedForChannel === channel);
      selected.forEach(item => {
        delete item.isSelectedForChannel;
      });

      const point = getTrackingPointByCode(cid, tailcode);
      if (point) {
        point.isSelectedForChannel = channel;
      }

      updateChannelLabel(channel);
      updateChannels();
    };

    vm.isTrackingPointBusy = ({ cid, tailcode }, channel) => {
      const point = getTrackingPointByCode(cid, tailcode);
      return point && point.isSelectedForChannel && point.isSelectedForChannel !== channel;
    };



    /* ************************************************************* */
    /* *********************** TV spot length ********************** */
    /* ************************************************************* */
    const vedIkke = 'Ved ikke';
    const dontKnow = 'Don’t know';
    vm.tvSpotLength = [
      '< 6',
      '10',
      '15',
      '20',
      '25',
      '30',
      '35',
      '40',
      '45',
      '50',
      '55',
      '60',
      '> 60',
      dontKnow,
    ];

    vm.selectedTvSpotLength = vm.dms.spotLength || vm.tvSpotLength[0];
    vm.onSelectTvSpotLength = value => {
      vm.selectedTvSpotLength = value === vedIkke ? dontKnow : value;

      updateDms({
        spotLength: value === dontKnow ? vedIkke : value,
      });
    };

    updateDms({
      spotLength: vm.selectedTvSpotLength,
    });


    /* ************************************************************* */
    /* *************************** Period ************************** */
    /* ************************************************************* */
    const updatePeriod = () => {
      const { start, end } = vm.campaign;
      const { startDate, endDate } = vm.dms;
      let period = {
        startDate: startDate || (start && new Date(start)),
        endDate: endDate || (end && new Date(end)),
      };

      if (!period.startDate || !period.endDate) {
        const monday = new Date();
        monday.setDate(monday.getDate() - (monday.getDay() + 6) % 7); // set to Monday of this week
        monday.setDate(monday.getDate() - 7); // set to previous Monday
        const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6); // create new date of sunday

        period = {
          startDate: monday,
          endDate: sunday,
        };
      }

      updateDms(period);
    }

    updatePeriod();

    const updatePeriodType = () => {
      const dateLong = $filter('dateLong');

      vm.periodType = [{
        key: 'exist',
        label: `Use campaign period (${dateLong(vm.dms.startDate)} - ${dateLong(vm.dms.endDate)})`,
      }, {
        key: 'selected',
        label: 'Select period',
      }];

      vm.selectedPeriod = vm.periodType[0];
    };

    vm.onSelectPeriod = key => {
      vm.selectedPeriod = vm.periodType.find(item => item.key == key);
      vm.showDatePicker = key === 'selected';

      if (key === 'exist') {
        updatePeriod();
      }
    }

    updatePeriodType();

    /* ************************************************************* */
    /* ************************* Date picker *********************** */
    /* ************************************************************* */
    $timeout(() => {
      if (vm.isDmsActive) {
        initDatepicker();
      }
    }, 250);

    function initDatepicker() {
      const picker = $('#datePickerDms');
      picker.daterangepicker({
        startDate: vm.dms.startDate,
        endDate: vm.dms.endDate,
        weekRanges: true,
        showWeekNumbers: true,
        locale: {
          firstDay: 1,
        },
        dateLimit: {
          months: 3,
        },
        format: 'yyyy-MM-dd',
      });

      const daterangepicker = $('.daterangepicker');
      daterangepicker.addClass('daterangepicker-static');
      picker.append(daterangepicker);

      picker.find('.calendar').click(() => {
        const data = picker.data('daterangepicker');
        updateDms({
          startDate: data.startDate,
          endDate: data.endDate,
        })
      });
    }



  /* ************************************************************* */
  /* *************************** Initial ************************* */
  /* ************************************************************* */
  if (vm.campaign.pid) {
    vm.processBusy = true;
    CampaignService.getCampaignOptionsDms({ id: vm.campaign.pid }).$promise
      .then(({ data }) => {
        vm.processBusy = false;

        if (data) {
          updateDms(data);
          initChannels(data.channels);
          vm.onSelectTvSpotLength(data.spotLength);
        }

        updatePeriod();
        updatePeriodType();
      });
    }

  }
})();
